import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claimGroups/${COMMON_QUERY_PARAMS.CLAIM_GROUP_ID}/additionalInformation`;

export interface AdditionalClaimInformationPayload {
  id: string;
  value?: string;
  forceValidation?: boolean;
}

export interface AdditionalInformationByClaimPayload {
  claimId: string;
  additionalClaimInformation?: AdditionalClaimInformationPayload[];
}

export interface SetClaimGroupAdditionalInformationCommandPayload {
  claimGroupId: string;
  additionalClaimInformationByClaims?: AdditionalInformationByClaimPayload[];
  additionalClaimInformation?: AdditionalClaimInformationPayload[];
}

export const setClaimGroupAdditionalInformationCommand = async ({
  claimGroupId,
  additionalClaimInformationByClaims,
  additionalClaimInformation,
}: SetClaimGroupAdditionalInformationCommandPayload): Promise<
  BaseBackResponse | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(
      COMMON_QUERY_PARAMS.CLAIM_GROUP_ID,
      claimGroupId,
    );

    const response = await apiCall<BaseBackResponse>(url, {
      method: SUPPORTED_METHODS.PUT,
      json: {
        additionalClaimInformationByClaims,
        additionalClaimInformation,
      },
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
